import * as SliderPrimitive from "@radix-ui/react-slider";
import * as React from "react";
import { cn } from "./cn";
export interface SliderProps extends Omit<
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root>,
  "value" | "onValueChange"
> {
  value?: number[];
  onValueChange?: (value: number[]) => void;
}

export const Slider = React.forwardRef<React.ComponentRef<typeof SliderPrimitive.Root>, SliderProps>(
  ({ className, ...props }, ref) => (
    <SliderPrimitive.Root
      ref={ref}
      className={cn("relative flex w-full select-none items-center pointer-events-auto cursor-pointer", className)}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-neutral-700/60 pointer-events-auto cursor-pointer">
        <SliderPrimitive.Range className="absolute h-full bg-lumi-accent pointer-events-auto" />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb className="block h-4 w-4 rounded-full border-2 border-neutral-900 bg-white shadow transition-colors hover:bg-neutral-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white pointer-events-auto cursor-grab active:cursor-grabbing" />
      <SliderPrimitive.Thumb className="block h-4 w-4 rounded-full border-2 border-neutral-900 bg-white shadow transition-colors hover:bg-neutral-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white pointer-events-auto cursor-grab active:cursor-grabbing" />
    </SliderPrimitive.Root>
  ),
);
Slider.displayName = "Slider";
